module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACnSURBVDhP7ZNBCsJADEXHRS/U9Eg200OIK3Gl697FjefxCgoZ852AWmNJdy788GHI/y8wMJO+SYgHof5SzYONY5KOdwpJIS4wzphZPC+h9f4VfluimdU+VVJaaWkzBad+dLRr2FPS5a0HeEbXsCodHL3inMFUuO0PXiFisFhw9cKIwSYvWOL/gp9YoN/15gURg9WHxCcvjBgsrtBIm0d9VedlzmMhbu7cUnF53sTYAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/img/6.png
// module id = 84
// module chunks = 0